import type React from 'react';

import { isBusyNow, useSchedule, useTz } from '@entities/schedules';
import cn from 'classnames';

import { getSessionBlock } from '@shared/helpers';

import * as st from './styles.module.scss';

interface Props {
	start: Date;
	end: Date;
	scheduleId: number;
	children?: React.ReactNode;
}

export const BusyContent: React.FC<Props> = ({ start, end, scheduleId, children }) => {
	const { schedule } = useSchedule(scheduleId);
	const { tz } = useTz();

	const blockType = getSessionBlock({ start, end }, tz, schedule?.start_time, schedule?.end_time);

	const isNow = isBusyNow(schedule);

	return (
		<div className={cn(st.content, st[blockType], isNow && st.now)}>
			{(blockType === 'start' || blockType === 'start_topOverlap' || blockType === 'single') &&
				children}
		</div>
	);
};
